import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AttendanceReportLanding from '../Components/AttendanceReport/AttendanceReportLanding';
import GrievanceContent from '../Components/Grievance/GrievanceContent';

class GrievanceContainer extends Component {
    constructor(props) {
        super(props);

        let us = JSON.parse(localStorage.getItem('user'));
        let username = us.user.email;

        this.state = {
            username: username,
            apikey: us.user.api_key
        }

    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} username={this.state.username} apikey={this.state.apikey} />
                <div className="main-body">
                    <GrievanceContent
                        history={this.props.history}
                        username={this.state.username}
                        apikey={this.state.apikey} />
                </div>
            </div>
        )
    }
}

export default withAuth(GrievanceContainer);